<template>
  <!-- Content -->
  <CRow>
    <CCol col="12">
      <CForm>
        <CModal
          title="Remover"
          color="danger"
          :show.sync="removeModal.show"
          :centered="true"
        >
          Ao confirmar essa ação o item não poderá ser recuperado, tem certeza
          que desejar continuar?
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary"
              @click="toggleModal"
            >
              Cancelar
            </button>
            <button type="button" class="btn btn-danger" @click="forceDelete">
              Remover
            </button>
          </template>
        </CModal>

        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <CButton color="danger ml-4" @click="toggleModal">
                Excluir Permanentemente
              </CButton>
              <a class="ml-4" href="javascript:void(0)" @click="$router.go(-1)"
                ><CIcon name="cil-arrow-left" class="mr-2" />Voltar</a
              >
            </div>
          </CCol>
        </CRow>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">Contato</h4>
          </CCardHeader>
        </CCard>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0 d-flex align-items-center">
              <CIcon name="cil-justify-center" class="mt-md-1 mr-2" />
              Informações
              <img
                v-if="languageFlag"
                :src="require(`@/assets/img/flags/${languageFlag}.svg`)"
                alt="Bandeira do idioma"
                class="flag ml-2 mt-sm-1"
              />
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol lg="12" md="12" sm="12">
                <CRow>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Data de envio</b><br />
                      {{
                        contact.dateFormatted
                          ? contact.dateFormatted
                          : 'Não Informado'
                      }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Nome</b><br />
                      {{ contact.name ? contact.name : 'Não Informado' }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>E-mail</b><br />
                      {{ contact.email ? contact.email : 'Não Informado' }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Telefone</b><br />
                      {{ contact.phone ? contact.phone : 'Não Informado' }}
                    </p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12" md="12" sm="12">
                <CRow>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Idioma</b><br />
                      {{
                        contact.language ? contact.language : 'Não Informado'
                      }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Departamento</b><br />
                      {{
                        contact.department
                          ? contact.department
                          : 'Não Informado'
                      }}
                    </p>
                  </CCol>
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>Empresa onde trabalha</b><br />
                      {{
                        contact.where_you_work
                          ? contact.where_you_work
                          : 'Não Informado'
                      }}
                    </p>
                  </CCol>

                  <!-- MOSTRAR APENAS SE O PAÍS NÃO FOR BRASIL -->
                  <CCol lg="3" md="3" sm="3">
                    <p>
                      <b>País</b><br />
                      {{ contact.country ? contact.country : 'Não Informado' }}
                    </p>
                  </CCol>
                </CRow>

                <CRow>
                  <CCol lg="12" md="12" sm="12">
                    <CRow>
                      <CCol md="12" lg="12">
                        <p>
                          <b>Mensagem</b><br />
                          {{
                            contact.message ? contact.message : 'Não Informado'
                          }}
                        </p>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon name="cil-justify-center" class="mb-1 mr-2" />
              Dados de endereço
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>CEP:</b><br />
                  {{ contact.zipcode ? contact.zipcode : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>Endereço:</b><br />
                  {{ contact.address ? contact.address : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>Número</b><br />
                  {{ contact.number ? contact.number : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>Bairro:</b><br />
                  {{
                    contact.neighborhood
                      ? contact.neighborhood
                      : 'Não informado'
                  }}
                </p>
              </CCol>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>Estado:</b><br />
                  {{ contact.uf ? contact.uf : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="2" md="2" sm="2">
                <p>
                  <b>Cidade:</b><br />
                  {{ contact.city ? contact.city : 'Não informado' }}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0">
              <CIcon name="cil-justify-center" class="mb-1 mr-2" />
              Dados restritos
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>IP:</b><br />
                  {{ contact.ip ? contact.ip : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Data aceite dos termos:</b><br />
                  {{ contact.accepted ? contact.accepted : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Navegador:</b><br />
                  {{ contact.browser ? contact.browser : 'Não informado' }}
                </p>
              </CCol>
              <CCol lg="3" md="3" sm="3">
                <p>
                  <b>Sistema operacional:</b><br />
                  {{ contact.os ? contact.os : 'Não informado' }}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Services
import Service from '@/services/contact.service'

import moment from 'moment'

export default {
  metaInfo: {
    title: 'Contato',
    titleTemplate: ' %s - Manager - Intelli'
  },

  data() {
    return {
      contact: {
        date: '22/07/2021',
        name: 'Nome',
        phone: '(16) 99999-9999',
        email: 'email@email.com',
        language: 'Português',
        department: 'Administrativo',
        where_you_work: 'OW Interactive',
        country: 'USA',
        uf: 'São Paulo',
        city: 'Ribeirão Preto',
        zipcode: '14010-100',
        address: 'Av. Presidente Vargas, 2230',
        neighborhood: 'Alto da Boa Vista',
        message:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis feugiat nisl. Sed vehicula libero vitae metus aliquam sodales. Praesent vestibulum vitae lectus vitae aliquam. Vestibulum pulvinar consectetur interdum. Sed et accumsan lorem, vitae faucibus sapien. Etiam consequat consequat purus, id pretium quam. Sed sed convallis risus, placerat placerat mauris. Pellentesque accumsan orci ac enim dapibus, et commodo purus condimentum. Aliquam ut rhoncus massa, in accumsan purus. Maecenas imperdiet finibus pretium.',
        accepted: '22/07/2021',
        ip: '200.171.63.323',
        browser: 'Chrome - 92.0.4515.131',
        os: 'Android - 8.0.0'
      },
      removeModal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  computed: {
    languageFlag() {
      const languageId = parseInt(this.contact.language_id)

      if (languageId === 1) {
        return 'pt-br'
      } else if (languageId === 2) {
        return 'en'
      } else if (languageId === 3) {
        return 'es'
      } else {
        return null
      }
    }
  },

  async created() {
    if (this.$route.params.id) {
      const response = await Service.show(this.$route.params.id)

      this.contact = {
        ...response.data,
        department: response.data.department.title,
        language: response.data.language.name,
        date: moment(response.data.created_at).format('DD/MM/YYYY'),
        accepted: moment(response.data.accepted_at).format('DD/MM/YYYY')
      }
    }
  },
  methods: {
    toggleModal() {
      this.removeModal.show = !this.removeModal.show
    },

    async forceDelete() {
      this.toggleModal()
      const response = await Service.forceDelete(this.$route.params.id, {
        type: 'Contato',
        name: this.contact.name
      })

      if (response && response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'O contato foi excluído conforme a LGPD'
        })
        setTimeout(() => {
          this.processing = false
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 500)
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Não é possivel excluir o contato'
        })
      }
    }
  }
}
</script>
